var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import LazyLoad from 'react-lazyload';
import Icon from '@alife/next-icon';
import { Button, BackgroundImage } from '@alife/simple-ui';
var CardConfirmOrder = (function (_super) {
    __extends(CardConfirmOrder, _super);
    function CardConfirmOrder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardConfirmOrder.prototype.render = function () {
        var _a = this.props, templateData = _a.templateData, _b = _a.locale, locale = _b === void 0 ? {} : _b, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, _d = _a.onEdit, onEdit = _d === void 0 ? function () { } : _d;
        var title = templateData.title, orderIcon = templateData.orderIcon, orderId = templateData.orderId, orderCount = templateData.orderCount, orderPrice = templateData.orderPrice, addrUserName = templateData.addrUserName, addrPhone = templateData.addrPhone, addrDetail2 = templateData.addrDetail2;
        return (React.createElement("div", { className: "card-confirm-order message-card", onClick: function () { return onClick(templateData); } },
            React.createElement("div", { className: "card-content" },
                React.createElement("div", { className: "lzd-row" },
                    React.createElement("div", { className: "lzd-col" },
                        React.createElement(Icon, { type: "form", size: "xs", className: "ic-card-tip" })),
                    React.createElement("div", { className: "lzd-col main-col" },
                        React.createElement("div", { className: "card-title" }, title),
                        React.createElement("div", { className: "card-intro" }, locale.confirmDesc),
                        React.createElement("div", { className: "card-order-preview" },
                            React.createElement(LazyLoad, { overflow: true, once: true, height: 62 },
                                React.createElement(BackgroundImage, { className: "lzd-order-img", src: orderIcon })),
                            React.createElement("div", { className: "order-content" },
                                React.createElement("div", { className: "lzd-line" },
                                    React.createElement("div", { className: "label" },
                                        locale.orderId || 'Order ID',
                                        ":"),
                                    React.createElement("div", { className: "field" }, orderId)),
                                React.createElement("div", { className: "lzd-line" },
                                    React.createElement("div", { className: "label" },
                                        locale.quantity || 'Quantity',
                                        ":"),
                                    React.createElement("div", { className: "field" }, orderCount)),
                                React.createElement("div", { className: "lzd-line order-price" },
                                    React.createElement("div", { className: "label" },
                                        locale.total || 'Total',
                                        ":"),
                                    React.createElement("div", { className: "field" }, orderPrice)))))),
                React.createElement("div", { className: "lzd-row" },
                    React.createElement("div", { className: "lzd-col lzd-cell" },
                        React.createElement("div", { className: "label" }, locale.contactName || 'Contact Name'),
                        React.createElement("div", { className: "field" }, addrUserName)),
                    React.createElement("div", { className: "lzd-col lzd-cell" },
                        React.createElement("div", { className: "label" }, locale.mobilePhone || 'Mobile Phone'),
                        React.createElement("div", { className: "field" }, addrPhone))),
                React.createElement("div", { className: "lzd-row" },
                    React.createElement("div", { className: "lzd-col lzd-cell" },
                        React.createElement("div", { className: "label" }, locale.address || 'Address'),
                        React.createElement("div", { className: "field" }, addrDetail2))),
                React.createElement("div", { className: "card-actions" },
                    React.createElement(Button, { className: "btn", onClick: function (e) {
                            e.stopPropagation();
                            onEdit(templateData);
                        } }, locale.edit || 'Edit')))));
    };
    return CardConfirmOrder;
}(React.Component));
export default CardConfirmOrder;

//# sourceMappingURL=index.js.map
